// extracted by mini-css-extract-plugin
export var container = "form-module--container--pHSAA";
export var content = "form-module--content--SRXie";